document.addEventListener("DOMContentLoaded", function () {
    const tooltips = document.querySelectorAll(".tooltip");

    tooltips.forEach((tooltip) => {
        tooltip.addEventListener("mouseenter", function () {
            const tooltipText = document.createElement("div");
            tooltipText.className = "tooltip-temp";
            tooltipText.innerText = tooltip.getAttribute("data-tooltip");
            document.body.appendChild(tooltipText);

            let rect = tooltip.getBoundingClientRect();
            let tooltipRect = tooltipText.getBoundingClientRect();

            document.body.removeChild(tooltipText);

            tooltip.classList.remove("tooltip-left");

            if (rect.left + tooltipRect.width > window.innerWidth + 120 ) { 
                tooltip.classList.add("tooltip-left");
            }
        });
    });
});
